/* eslint-disable no-console */
// 中行接入桥接器
import LoadScript from '@/utils/loadScript';
import Env from '@/utils/env';
import { DeviceReady, SYSTEM_CODE_MAP } from './utils';
import { upload } from './api';

interface IPicUrl {
  url: string;
}

let path = 'https://ebsnew.boc.cn/bocphone/BocMerchant/';
if (Env.isAndroid) {
  path += 'paylib/android.js';
}
if (Env.isIOS) {
  path += 'paylib/ios.js';
}

let loadPromise: Promise<[void, void]>;

function loadSdk() {
  if (!loadPromise) {
    loadPromise = Promise.all([LoadScript(path, () => {}), DeviceReady()]);
  }
  return loadPromise;
}
if (Env.systemCode === SYSTEM_CODE_MAP.BOC) {
  loadSdk();
}

const { userAgent } = window.navigator;
// @ts-ignore
const appVersion = userAgent.indexOf('bocapp(') > -1 ? userAgent.match(/bocapp\(\S+\)/)[0].slice(7, -1) : '3.0.0';
const matchSequence = userAgent.match(/appSequence:([^;]*);/);
const appSequence = (matchSequence && matchSequence[1]) || 0;

function compareVersion(version: string) {
  const v1 = appVersion.split('.');
  const v2 = version.split('.');
  for (let i = 0; i < v1.length; i += 1) {
    // @ts-ignore
    if (v1[i] * 1 > v2[i] * 1) {
      return 1; // 当前版本号大于要求最低版本号
      // @ts-ignore
    } if (v1[i] * 1 < v2[i] * 1) {
      return -1; // 当前版本号小于要求最低版本号
    }
  }
  return 0; // 当前版本号等于要求最低版本号
}

// 用于判断蓝牙版本控制
function compareSequence() {
  return Number(appSequence) < 22200;
}

/**
 * 获取中行直接扫一扫信息
 * @date 2021-09-17
 * @returns {any}
 */
export function getBocCustInfo(keys: {[key:string]: any}) {
  const res = compareVersion('6.11.4');
  if (res === -1) {
    window?.showToast('当前版本号过低，请升级最新版APP！');
    return false;
  }
  return new Promise((resolve, reject) => {
    try {
      loadSdk().then(() => {
        window.c_plugins.containerAirBridge.getParams((data: {[key:string]: any}) => {
          // console.info('getBocCustInfo.............', data);
          resolve(data);
        }, (error: {[key:string]: any}) => {
          reject(error);
        }, {
          keys,
        });
      });
    } catch (error) {
      reject(error);
    }
  });
}

/**
 * 获取定位
 * @date 2021-09-17
 * @returns {any}
 */
export function getLocation() {
  return new Promise((resolve, reject) => {
    try {
      loadSdk().then(() => {
        // resolve({"lng": 121.383134, "lat": 31.159233, "addrStr": "上海市闵行区龙茗路", "city": "上海市", "cityCode": "310112", "district": "闵行区", "latitude": 31.159233, "longitude": 121.383134, "nation": "中国", "nationCode": "156", "province": "上海市", "districtCode": "310112"});
        window.c_plugins.merchantBridge.getLocationInfo((data: { latitude: number; longitude: number;}) => {
          const { latitude, longitude } = data || {};
          resolve({
            lng: longitude,
            lat: latitude,
            ...data,
          });
        }, (err: {[key:string]: any}) => {
          reject(err);
        }, {});
        // resolve({
        //   addrStr: '上海市闵行区园秀路28弄2号',
        //   city: '上海市',
        //   cityCode: '310112',
        //   district: '闵行区',
        //   latitude: 31.123103,
        //   longitude: 121.365062,
        //   nation: '中国',
        //   nationCode: '156',
        //   province: '上海市',
        //   districtCode: '310112',
        // });
      });
    } catch (err) {
      reject(err);
    }
  });
}

/**
 * 拍照
 * @date 2021-09-17
 * @returns {any}
 */
export function addPhoto() {
  return new Promise((resolve, reject) => {
    try {
      loadSdk().then(() => {
        // resolve({"lng": 121.383134, "lat": 31.159233, "addrStr": "上海市闵行区龙茗路", "city": "上海市", "cityCode": "310112", "district": "闵行区", "latitude": 31.159233, "longitude": 121.383134, "nation": "中国", "nationCode": "156", "province": "上海市", "districtCode": "310112"});
        window.c_plugins.merchantBridge.getLocalImage((data: {[key:string]: any}) => {
          const { imgStr } = data || {};
          resolve({
            data: imgStr,
          });
        }, (err: {[key:string]: any}) => {
          reject(err);
        }, {});
      });
    } catch (err) {
      reject(err);
    }
  });
}

export async function uploadFile(imgStr: string): Promise<{ data: IPicUrl } | undefined | void> {
  // base64图片，该接口不能携带前缀，data:image/jpeg;base64,
  const url = await upload(imgStr);
  return Promise.resolve({
    data: { url },
  });
};

/**
 * 调起扫码
 * @date 2021-09-17
 * @returns {any}
 */
export function scan() {
  const res = compareVersion('5.1.0');
  if (res === -1) {
    window.showToast('当前版本号过低，请升级最新版APP！');
    return false;
  }
  return new Promise((resolve, reject) => {
    try {
      loadSdk().then(() => {
        window.c_plugins.merchantBridge.decoderQrCode((data: {[key:string]: any}) => {
          resolve({
            data: {
              result: data && data.qrValue,
            }
          });
        }, (err: {[key:string]: any}) => {
          reject(err);
        }, {
          qrType: '1',
        });
      });
    } catch (err) {
      reject();
    }
  });
}

/**
 * 打开webview
 * @date 2021-09-17
 * @returns {any}
 */
export function openWebview({ url }: {url: string}) {
  // window.onpageshow = null;
  // window.onpageshow = () => {
  //   // eslint-disable-next-line no-restricted-globals
  //   location.reload();
  // };
  window.location.href = url;
}

export function shock() { }
export function previewImage() { }
export function getAppInfo() { }
export function go() { }
